
import { Component, OnInit, HostListener } from '@angular/core';
import { WindowRef } from '../../utils/window';
import { Router } from '@angular/router';
import { Subject ,  Observable ,  Subscription } from 'rxjs';
import { APP_CONSTANTS } from '../../utils/app-constants';
import { AuthorizationService } from '../../components/authorization/authorization.service';
import { FormGroup, Validators, FormControl, FormBuilder, AbstractControl, ValidationErrors, ValidatorFn, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateUtil } from '../../utils/translate-util';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { RecaptchaLoaderService } from '../../utils/recaptchaLoader.service';
import { DTFHomepageService } from '../../components/dtfhomepage/dtfhomepage.service'
import { HeaderComponent } from '../../furniture/header.component';
import { MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';

import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { SharedTranslateModule } from '../../utils/sharedTranslateModule';
import { VideoComponent } from '../video/video.component';
import { MatButtonModule } from '@angular/material/button';


declare var grecaptcha: any;
export enum CheckBoxType { 
    ENROLL_AUTOPAY, 
    ENROLL_EBILL,
    LATER, NONE 
};


@Component({
    selector: 'div.dtf-registrationPopuppage',
    imports: [SharedTranslateModule,
        MatTableModule, MatCheckboxModule, MatFormFieldModule,
        MatInputModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatButtonToggleModule, MatSortModule
    ],
    templateUrl: './registrationPopup.component.html',
    providers: [WindowRef]
})


export class RegistrationPopupComponent implements OnInit {

    constructor(router: Router, window: WindowRef,
                public auth: AuthorizationService, private fb: FormBuilder,public translateUtil: TranslateUtil,
                public translate: TranslateService, public recaptchaLoaderService: RecaptchaLoaderService,
                public dtfhomepageService: DTFHomepageService, public headerComponent: HeaderComponent, public dialog: MatDialog
                ) {
        this.router = router;
        this._window = window;
        this.contextPath = (this._window.nativeWindow as any).mbfs.contextPath;
        this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
        this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;
    }
    check_box_type = CheckBoxType;

  currentlyChecked: CheckBoxType;
    private _window: WindowRef;
    router: Router;
    public registration: any;
    isAuthenticated = false;
    ciamLoginUrl = '';
    contextPath = '';
    currentCountry: string;
    isCanadaPortal = false;
    isReset = false;
    hasUpperCase = false;
    hasLowerCase = false;
    loader=false;
    hasNumeric = false;
    hasMinimum = false;
    hasMaximum = false;
    hasSpecialCharacter = false;
    userIDcheck = false;
    reentercheck = false;
    videoredirect = '';
    showVideo=false;
    reenteremailcheck=false;
    hide = false;
    hide2 = false;
    userExist = false;
    profileExist = false;
    optionExist =false;
    autopayExist=false;
    successExist =false;
    userblock =false;
    loginLoaded = true;
    enableEbillContinue = false;
    rendered: any;
    captchaToggle = true;
    isAuth = '';
    userId = '';
    customerNumber ='';
    contractNumber ='';
    emailAddress ='';
    maskedEmail='';
    password = '';
    repassword='';
    language = '';
    openLoginModal = false;
    serviceErrorOccurred = false;
    serviceErrorDesc = '';
    usUrl: string;
    caUrl: string;
    brandId: string;
    targetRedirect = '';
    registrationRedirect = '';
    baseUrl = '';
    logoutRedirect = '';
    classicRedirect = '';
    environment = '';
    siteKeyCaptcha = '';
    recaptchaResponse = '';
    private recaptchaURL = APP_CONSTANTS.recaptchaURL;
    contractRequest: any = {};
    accountRequest: any = {};
    ebillRequest: any ={};
    emailOffers = true;
   optionForm:FormGroup;
    loginForm: FormGroup;
    userForm: FormGroup;
    passwordForm: FormGroup;
    emailForm: FormGroup;
    profileForm: FormGroup;
    autopayForm: FormGroup;
    ciamReCaptchaForm: FormGroup;
    numAttempts = false;
    userActive= false;
    langFlag: string;
    formValidationClasses = {
      'mbfs-error': true,
    };

    buildForm() {
      this.userForm = this.fb.group({
        userID: [''],
        password:[''],
        repassword:[''],
      });
      this.passwordForm = this.fb.group({
        password:[''],
        repassword:['']
      });
      this.emailForm= this.fb.group({
        emailAddress:[''],
        reEnterEmailAddress:['']
      });
      this.profileForm = this.fb.group({
        contractNumber: [''],
       customerNumber:[''],
       emailAddress:[''],
      });
      this.loginForm = this.fb.group({
        userID: [''],
        password: ['']
      });
      this.ciamReCaptchaForm = this.fb.group({
        recaptchaResponseKey: [null, Validators.required]
    });
    this.optionForm = this.fb.group({
      eBill: [''],
     Autopay:[''],
     none: ['']
    });
    this.autopayForm = this.fb.group({
      bankRoutingNumber: [''],
     bankAccountNumber:['']
    });
    }

    selectSiteKey() {
      this.environment = (this._window.nativeWindow as any).mbfs.environment;
      if (this.environment === 'local') {
       this.siteKeyCaptcha = APP_CONSTANTS.siteKeyCaptchaLocal;
      } else if (this.environment === 'dev') {
        this.siteKeyCaptcha = APP_CONSTANTS.siteKeyCaptchaDev;
      } else if (this.environment === 'stage') {
        this.siteKeyCaptcha = APP_CONSTANTS.siteKeyCaptchaStage;
      } else if (this.environment === 'prod') {
        this.siteKeyCaptcha = APP_CONSTANTS.siteKeyCaptchaProd;
      } else {
        this.siteKeyCaptcha = APP_CONSTANTS.siteKeyCaptchaProd;
      }
    }

  getCaptcha() {
    this.dtfhomepageService.getCaptcha().subscribe((res) => {
      this.captchaToggle = res;
    });
  }

    ngOnInit() {
      this.getCaptcha();
      const language = (window as any).mbfs.language;
      this.langFlag = language;
      this.translateUtil.setCountryAndLangFromUIProp();
      this.translateUtil.getCurrentCountry().subscribe(val => {
          this.isCanadaPortal = (val === APP_CONSTANTS.COUNTRY_CA) ? true : false;
          this.currentCountry = val;
      });
      this.auth.cast.subscribe(data => (this.isAuthenticated = data));
      this.contextPath = (this._window.nativeWindow as any).mbfs.contextPath;
      this.language = (this._window.nativeWindow as any).mbfs.language;
      if(this.isCanadaPortal === true){
        this.brandId = '3';
      }
      else{
        this.brandId = '2';
      }
     sessionStorage.setItem('brandId',this.brandId);
      this.auth.isAuthenticated(); // Checks if user is authenticated
      let element:HTMLElement = document.getElementById('auto_trigger_registration') as HTMLElement;
      element.click();
      // this.onClickLogin(this.e);
    }
    goBack(){
      this.openLoginModal=true;
      this.userExist = false;
      this.profileExist = false;
    }
    onClickLogin(e: Event): void {
      this.onClickCloseNewNav(e);
      this.buildForm();
      this.selectSiteKey(); // used to set Site key based on environment
      //recaptcha script load
      if(this.language === 'fr-CA') {
        this.recaptchaURL = APP_CONSTANTS.recaptchaURLFR;
      } else {
        this.recaptchaURL = APP_CONSTANTS.recaptchaURL;
      }
      if (this.captchaToggle) {
      window['onloadCallback'] = this.onloadCallback.bind(this);
      window['getResponceCapcha'] = this.getResponceCapcha.bind(this);
      window['recaptchaResponseExpired'] = this.recaptchaResponseExpired.bind(this);
      window['recaptchaError'] = this.recaptchaError.bind(this);

      this.recaptchaLoaderService.loadScript(this.recaptchaURL)
          .then(data => {
          }).catch(error => console.log(error));
      }
      //build login form
      this.openLoginModal = true;
      this.userForm.get('userID').setValidators(
        Validators.compose([Validators.required,
             Validators.minLength(8),
             Validators.maxLength(60)])
      );
      // this.userForm.get('password').setValidators(
      //   Validators.compose([Validators.required,
      //   Validators.minLength(12),
      //   Validators.maxLength(30),
      //   this.passwordValidationCheck(),
      //   Validators.pattern('^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!_@#$&*?:=])(?=\\S+$).{12,30}$')])
      // );
      // this.userForm.get('repassword').setValidators(
      //   Validators.compose([Validators.required,
      //   Validators.minLength(12),
      //   Validators.maxLength(30),
      //   this.passwordEqualsCheck(),
      //   Validators.pattern('^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!_@#$&*?:=])(?=\\S+$).{12,30}$')]),
      // );
      this.profileForm.get('emailAddress').setValidators(
        Validators.compose([Validators.required,
        Validators.minLength(12),
        Validators.maxLength(60),
        Validators.pattern('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+[\.]+[a-z]{2,4}$')])
      );
      this.userForm.get('password').setValidators(
        Validators.compose([Validators.required,
        Validators.minLength(12),
        Validators.maxLength(30),
        this.passwordValidationCheck(),
        Validators.pattern('^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!_@#$&*?:=])(?=\\S+$).{12,30}$')])
      );
      this.userForm.get('repassword').setValidators(
        Validators.compose([Validators.required,
        Validators.minLength(12),
        Validators.maxLength(30),
        this.passwordEqualsCheck(),
        Validators.pattern('^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!_@#$&*?:=])(?=\\S+$).{12,30}$')]),
      );

      // this.emailForm.get('emailAddress').setValidators(
      //   Validators.compose([Validators.required,
      //   Validators.minLength(12),
      //   Validators.maxLength(60),
      //   Validators.pattern('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+[\.]+[a-z]{2,4}$')])
      // );
      // this.emailForm.get('reEnterEmailAddress').setValidators(
      //   Validators.compose([Validators.required,
      //   Validators.minLength(12),
      //   Validators.maxLength(60),
      //   this.EqualsCheck(),
      //   Validators.pattern('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+[\.]+[a-z]{2,4}$')])
      // );
      this.profileForm.get('contractNumber').setValidators(
        Validators.compose([Validators.required,
             Validators.minLength(4),
             Validators.maxLength(13)])
      );
      this.profileForm.get('customerNumber').setValidators(
        Validators.compose([Validators.required,
             Validators.minLength(10),
             Validators.maxLength(10)])
      );
      // this.autopayForm.get('bankRoutingNumber').setValidators(
      //   Validators.compose([Validators.required,
      //        Validators.minLength(13),
      //        Validators.maxLength(13)])
      // );
      // this.autopayForm.get('bankAccountNumber').setValidators(
      //   Validators.compose([Validators.required,
      //        Validators.minLength(10),
      //        Validators.maxLength(10)])
      // );
      }



  closeCIAMModal(e: Event) {
    this.openLoginModal = false;
    this.userExist = false;
    this.numAttempts = false;
    this.userActive = false;
    this.profileExist =false;
    this.reentercheck=false;
    this.isReset = false;
    this.optionExist =false;
    this.autopayExist =false;
    this.serviceErrorOccurred = false;
    this.userblock =false;
    this.enableEbillContinue = false;
    this.successExist = false;
    this.headerComponent.registrationClick = false;
  }
  
  // submitUserForm(e: Event) {
  //   if (!this.userForm.valid) {
  //     this.translate.get('Errors.userId_passwordMatch').subscribe((data:any)=> {
  //       this.serviceErrorDesc = data;
  //      });
  //     this.serviceErrorOccurred = true;
  //     setTimeout(() => {
  //       this.serviceErrorOccurred = false;
  //     }, 2000);  //2s
  //     return;
  //   }
  //   if (this.captchaToggle) {
  //   if (this.ciamReCaptchaForm.invalid) {
  //     this.translate.get('Errors.recaptcha').subscribe((data: any) => {
  //       this.serviceErrorDesc = data;
  //       return;
  //      });
  //   }
  //  }
  //   this.userId = this.userForm.get('userID').value;

  //   if (this.captchaToggle) {
  //   const userRequest = {
  //     userId : this.userId,
  //     recaptcha : this.recaptchaResponse
  //   };
  //   this.getUser(userRequest);
  //  } else {
  //   const userRequest = {
  //     userId : this.userId,
  //     recaptcha : 'false'
  //   };
  //   this.getUser(userRequest);
  //  }
  //  this.profileExist = true;
  // }
 

  userBlockBool(e: Event){
    if (this.captchaToggle) {
        if (this.ciamReCaptchaForm.invalid) {
          this.translate.get('Errors.recaptcha').subscribe((data: any) => {
            this.serviceErrorDesc = data;
            return;
           });
        }
       }
    let resetvalue = this.userForm.get('repassword').value;
    let passwordvalue = this.userForm.get('password').value;
    if ((resetvalue === passwordvalue) && resetvalue !=null && resetvalue !="") {
      // this.userblock=true;
      this.profileExist=true;
    }
    else{
      this.translate.get('Errors.userId_passwordMatch').subscribe((data:any)=> {
        this.serviceErrorDesc = data;
       });
       this.serviceErrorOccurred = true;
      setTimeout(() => {
        this.serviceErrorOccurred = false;
      }, 7000);  //2s
    }
  }

//   submitAutopayForm(e : Event){
// this.successExist = true;
//   }

  onloadCallback() {
    this.rendered = grecaptcha.render('capcha_element', {
        'sitekey': this.siteKeyCaptcha,
        'lang': this.language
    });
}


  getResponceCapcha(captchaResponse: string) {
    // this.verifyCaptcha(captchaResponse);
    this.ciamReCaptchaForm.controls.recaptchaResponseKey.setValue(captchaResponse);
    (this._window.nativeWindow as any).scrollBy(0, 1);
    this.recaptchaResponse = this.ciamReCaptchaForm.controls.recaptchaResponseKey.value;
}

recaptchaResponseExpired() {
    this.ciamReCaptchaForm.controls.recaptchaResponseKey.setValue(null);
    grecaptcha.reset(this.rendered);
}
recaptchaError() {
    this.ciamReCaptchaForm.controls.recaptchaResponseKey.setValue(null);
    this.translate.get('Errors.recaptcha').subscribe((data: any) => {
      this.serviceErrorDesc = data;
     });
}

  changeType(input_field_password, num){
    if(input_field_password.type === 'password') {
      input_field_password.type = 'text';
    } else {
      input_field_password.type = 'password';
    }
    this.hide = !this.hide;
  }

  selectCheckBox(targetType: CheckBoxType) {
    // If the checkbox was already checked, clear the currentlyChecked variable
    if(this.currentlyChecked === targetType) {
      this.enableEbillContinue = false;
      this.currentlyChecked = CheckBoxType.NONE;
      return;
    }

    this.currentlyChecked = targetType;
    if(targetType !=null){
      this.enableEbillContinue = true;
    }
  }
  passwordValidationCheck(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      let passwordvalue = this.userForm.get('password').value;
      let notUserId = false;
      if (passwordvalue != this.userId) {
        notUserId = true;
      }
      this.userIDcheck = notUserId;
      this.hasUpperCase = /[A-Z]+/.test(passwordvalue);
      this.hasLowerCase = /[a-z]+/.test(passwordvalue);
      this.hasNumeric = /[0-9]+/.test(passwordvalue);
      this.hasMinimum = passwordvalue.length >= 12;
      this.hasMaximum = passwordvalue.length <= 30;
      this.hasSpecialCharacter = /^(?=.*[!_@#$&*?:=])(?=\S+$)/.test(passwordvalue);
      const passwordValid = this.hasUpperCase && this.hasLowerCase && this.hasNumeric && this.userIDcheck && this.hasSpecialCharacter;

      return !passwordValid ? { passwordStrength: true } : null;
    }
  }

  passwordEqualsCheck(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      let resetvalue = this.userForm.get('repassword').value;
      let passwordvalue = this.userForm.get('password').value;
      let notpasswordEqual = false;
      if (resetvalue === passwordvalue) {
        notpasswordEqual = true;
      }
      this.reentercheck = notpasswordEqual;
      const passwordValid = this.reentercheck;
      return !passwordValid ? { passwordStrength: true } : null;
    }
  }
  EqualsCheck(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      let email1value = this.emailForm.get('reEnterEmailAddress').value;
      let email2value = this.emailForm.get('emailAddress').value;
      let notemailEqual = false;
      if (email1value === email2value) {
        notemailEqual = true;
      }
      this.reenteremailcheck = notemailEqual;
      const emailValid = this.reenteremailcheck;
      return !emailValid ? { mailStrength: true } : null;
    }
  }

verifyUserId(event: Event){
  if (!this.userForm.valid) {
    this.translate.get('Errors.userId_passwordMatch').subscribe((data: any) => {
      this.serviceErrorDesc = data;
    });
    this.serviceErrorOccurred = true;
    setTimeout(() => {
      this.serviceErrorOccurred = false;
    }, 7000);  //2s
    return;
  }

  let userID = this.userForm.get('userID').value;
  let password =this.userForm.get('password').value;

  // let emailAddress = this.userForm.get('emailAddress').value;

  let userRequest = {
    ciamId : userID,
    password:password
  };

  this.loginLoaded = false; //Spinner enabler
  this.auth.verifyUserId(userRequest).subscribe(res => {
    this.loginLoaded = true; //Spinner enabler
    if(res.statusMessage==='SUCCESS')
    {
      this.profileExist=true;
    }
    else{
      this.translate.get('Errors.emailpattern').subscribe((data: any) => {
        this.serviceErrorDesc = data;
      });
      this.serviceErrorOccurred = true;
      setTimeout(() => {
        this.serviceErrorOccurred = false;
      }, 7000);  //2s
    }

   
  });
}

prepareToRegisterUser(event: Event){
  this.contractRequest = {};
  if (!this.passwordForm.valid) {
    this.translate.get('Errors.userId_passwordMatch').subscribe((data: any) => {
      this.serviceErrorDesc = data;
    });
    this.serviceErrorOccurred = true;
    setTimeout(() => {
      this.serviceErrorOccurred = false;
    }, 7000);  //2s
    return;
  }
  let userID = this.userForm.get('userID').value;
  let password = this.passwordForm.get('password').value;
  let contractRequest = {
    ciamId : userID,
    password: password,
    brandId: this.brandId,
    email:this.userForm.get('emailAddress').value
  };
  this.loginLoaded = false; //Spinner enabler
  this.auth.prepareToRegisterUser(contractRequest).subscribe(res => {
    this.loginLoaded = true;
    if(res.statusMessage==='SUCCESS')
    {
      this.profileExist=true;
    }
    else{
      this.translate.get('Errors.userId_passwordMatch').subscribe((data: any) => {
        this.serviceErrorDesc = data;
      });
      this.serviceErrorOccurred = true;
      setTimeout(() => {
        this.serviceErrorOccurred = false;
      }, 7000);  //2s
    }
  });
}

prepareAccountSetup(e: Event) {
  console.log(this.profileForm);
  this.accountRequest = {};
  if (!this.profileForm.valid) {
    this.translate.get('Errors.userId_passwordMatch').subscribe((data:any)=> {
      this.serviceErrorDesc = data;
     });
    this.serviceErrorOccurred = true;
    setTimeout(() => {
      this.serviceErrorOccurred = false;
    }, 2000);  //2s
    return;
  }
  let userID = this.userForm.get('userID').value;
  let email=this.profileForm.get('emailAddress').value;
  let password=this.userForm.get('password').value
  this.emailAddress=email;
   let contractNumber= this.profileForm.get('contractNumber').value;
  let customerNumber = this.profileForm.get('customerNumber').value;
 
  let accountRequest = {
    ciamId : userID,
    accountNumber :contractNumber,
    thirdPartyNumber : customerNumber,
    brandId: this.brandId,
    email:email,
    language: this.language,
    password: password
   };
   
  this.loginLoaded = false; //Spinner enabler
  this.auth.prepareAccountSetup(accountRequest).subscribe(res => {
    this.loginLoaded = true;
    if(res.statusMessage==='SUCCESS')
    {
      this.userblock = true;
      this.maskedEmail=this.maskEmail(email)
     //  this.prepareEmailSetup();
      this.optionExist = true;
    }
    else{
      this.deleteUser();
      if(res.restartFlow)
      this.openDialog(1);
    else
    this.openDialog(2);

    }
  });
}

deleteUser(){
    let userID = this.userForm.get('userID').value;
    // let email=this.userForm.get('emailAddress').value;
    // this.emailAddress=email;
    // let contractNumber= this.profileForm.get('contractNumber').value;
    // let customerNumber = this.profileForm.get('customerNumber').value;

    let accountRequest = {
    ciamId : userID
   };

  //delete user from profile, userlockout and user table.
  this.auth.deleteUser(accountRequest).subscribe(res => {});
}

maskEmail(email: string): string {
  if (!email) return '';

  const [user, domain] = email.split('@');
  if (!domain) return email;

  // Mask user: show first 2 chars, then ***
  const maskedUser = user.length <= 2
    ? user[0] + '*'.repeat(user.length - 1)
    : user.slice(0, 2) + '*'.repeat(user.length - 2);

  // Mask domain name before dot, show only first char + ***
  const domainParts = domain.split('.');
  if (domainParts.length < 2) return email;

  const domainName = domainParts[0];
  const domainExt = domainParts.slice(1).join('.');

  const maskedDomain = domainName.length <= 1
    ? domainName + '*'.repeat(domainName.length)
    : domainName[0] + '*'.repeat(domainName.length - 1);

  return `${maskedUser}@${maskedDomain}.${domainExt}`;
}
prepareEmailSetup(){
  this.contractRequest = {};
  // if (!this.emailForm.valid) {
  //   this.translate.get('Errors.userId_passwordMatch').subscribe((data:any)=> {
  //     this.serviceErrorDesc = data;
  //     });
  //   this.serviceErrorOccurred = true;
  //   setTimeout(() => {
  //     this.serviceErrorOccurred = false;
  //   }, 2000);  //2s
  //   return;
  // }
  let userID = this.userForm.get('userID').value;
  this.emailAddress = this.userForm.get('emailAddress').value;

  sessionStorage.setItem('emailAddress',this.emailAddress);

  let emailRequest = {
    ciamId : userID,
    email: this.emailAddress,
    language: this.language,
    brandId: this.brandId,
    emailOffer: this.emailOffers
  };
  this.loginLoaded = false; //Spinner enabler
  this.auth.updateAndSendEmailToUser(emailRequest).subscribe(res => {
    this.loginLoaded = true; // Spinner enabler
    if (res.statusMessage === 'SUCCESS') {
      this.optionExist = true;
    } else if (res.statusMessage === 'FAILURE' && res.emailCount > 3) {
      this.translate.get('LoginModal.Attempts').subscribe((data: any) => {
        this.serviceErrorDesc = data;
      });
      this.numAttempts = true;
      this.serviceErrorOccurred = true;
      setTimeout(() => {
        this.serviceErrorOccurred = false;
      },10000);  // 10s
    } else if (res.statusMessage === 'FAILURE' && (res.isUserIdValid === 'User is already active')) {
      this.userActive = true;
    } else if (res.statusMessage === 'Email address is already in use') {
      this.translate.get('Errors.emailAddressInUse').subscribe((data: any) => {
        this.serviceErrorDesc = data;
      });
      this.serviceErrorOccurred = true;
      setTimeout(() => {
        this.serviceErrorOccurred = false;
      }, 10000);  // 10s
    } else {
      this.translate.get('Errors.userId_passwordMatch').subscribe((data: any) => {
        this.serviceErrorDesc = data;
      });
      this.serviceErrorOccurred = true;
      setTimeout(() => {
        this.serviceErrorOccurred = false;
      }, 10000);  // 10s
    }
  });


}

onClickCloseNewNav(e: Event) {
  if (e instanceof Event) {
      e.preventDefault();
      e.stopPropagation();
  }
}

   openLogin(e: Event) {
    this.openLoginModal = false;
    this.userExist = false;
    this.isReset = false;
    this.serviceErrorOccurred = false;
    let redirect = '';
    this.translate.get('LoginModal.LoginRedirect').subscribe((data:any)=> {
      redirect= this.usUrl +  data;
     });
     window.location.href = redirect;
  }

  openRegistration(e: Event) {
    this.openLoginModal = false;
    this.userExist = false;
    this.isReset = false;
    this.serviceErrorOccurred = false;
    let redirect = '';
    this.translate.get('LoginModal.RegistrationRedirect').subscribe((data:any)=> {
      redirect= this.usUrl +  data;
     });
     window.location.href = redirect;
  }

  clickvideo(redirect: string){
    sessionStorage.removeItem('videoRedirect');
    this.showVideo = false;
    if(redirect === "registration"){
      this.videoredirect = this.usUrl + "/static/videos/DTFWebsite-RegistrationSection6-3-24_1.mp4";
      sessionStorage.setItem('videoRedirect', this.videoredirect);

      let azURL =  this.usUrl + '/home/video';
      setTimeout(() => {
        window.open(azURL, '_blank', 'width=1200, height=900');
      }, 500);  //1s
    } 
    else if(redirect === "registrationCA"){
      if(this.langFlag === 'fr-CA'){
        this.videoredirect = this.usUrl + "/static/videos/DTFWebsite-RegistrationCAFrench.mp4";
        
        sessionStorage.setItem('videoRedirect', this.videoredirect);
        let azURL =  this.usUrl + '/ca/fr/home/video';

        setTimeout(() => {
          window.open(azURL, '_blank', 'width=1200, height=900');
        }, 500);  //1s
      }
      else{
        this.videoredirect = this.usUrl + "/static/videos/DTFWebsite-RegistrationCAEnglish.mp4";

        sessionStorage.setItem('videoRedirect', this.videoredirect);
        let azURL =  this.usUrl + '/ca/en/home/video';
    
        setTimeout(() => {
          window.open(azURL, '_blank', 'width=1200, height=900');
        }, 500);  //1s
      }
    }

   
  }


  openDialog(num: any) {
    if (num === 1) {
      sessionStorage.setItem('dialog', 'one');
    }
    if (num === 2) {
      sessionStorage.setItem('dialog', 'two');
    }

    this.dialog.open(RegistrationPopupDialogComponent, {
      maxWidth: '500vw',
      width: '1000px',
  });
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }
}


@Component({
    selector: 'dialog-elements-example-dialog',
    imports: [SharedTranslateModule, MatButtonModule,
        MatDialogContent, MatDialogActions,
        MatDialogClose],
    templateUrl: 'registrationPopupDialog.component.html'
})
export class RegistrationPopupDialogComponent {
  dialog: string;
  constructor(){
    this.dialog = sessionStorage.getItem('dialog');
  }
}